module.exports = __webpack_public_path__ + "assets/106bcfda60dba5010fabdd5a002fef9c.mp3";